import axios from 'axios';

const http = axios.create({
	baseURL: 'https://ica-api.18yimu.com', // 你的API基础URL
	timeout: 100000, // 请求超时时间
});

// 请求拦截器
http.interceptors.request.use(
	config => {
		// 可以在这里统一添加token等请求头信息
		// const token = localStorage.getItem('token'); // 假设token存储在localStorage中
		// if (token) {
		//   config.headers.Authorization = `Bearer ${token}`;
		// }
		// console.group('🚀 Axios 请求详情')
		// console.log('📤 请求方法:', config.method?.toUpperCase())
		// console.log('🔗 请求完整URL:', config.baseURL + (config.url || ''))
		// console.log('📍 请求路径:', config.url)
		// console.log('🎯 代理目标:', config.baseURL)
		// console.log('📋 请求头:', config.headers)
		// console.log('📦 请求数据:', config.data)
		// console.log('⏰ 超时时间:', config.timeout)

		// // 检查是否是代理请求
		// const isProxyRequest = config.url?.startsWith('/api') ||
		// 	config.baseURL?.includes('/api') ||
		// 	config.url?.includes('localhost:8080')
		// console.log('  - 是否是代理请求:', isProxyRequest ? '✅ 是' : '❌ 否')
		return config;
	},
	error => {
		// 处理请求错误
		return Promise.reject(error);
	}
);

// 响应拦截器
http.interceptors.response.use(
	response => {
		console.log(response);
		// 对响应数据做点什么
		return response.data; // 根据实际情况决定是否返回response.data
	},
	error => {
		console.log(error);
		// 处理响应错误，例如401未授权则跳转到登录页面等
		if (error.response && error.response.status === 401) {
			// 例如跳转到登录页面或显示错误信息等
			console.error('Unauthorized, please login again.');
		}
		return Promise.reject(error); // 返回Promise拒绝，可以在调用处通过catch捕获错误处理
	}
);


export default http;